import * as sale_api from "@/api/module/sale"
import { mapGetters ,mapMutations} from 'vuex'
import debounce from 'debounce';

export default {
  computed: {
    ...mapGetters({
      mutil_index   :'get_mutil_index',

      vip_info      :'vip_info',
      vip_saved     :'vip_saved',

      sum_info      :'get_products_sum_info',
      pay_info      :'get_pay_info',
      order_id      :'get_order_id',
      order_note    :'get_order_note',

      prodcuts_list :'get_prodcuts_list',
      selected_num  :'get_selected_num',

      outsea_products:'get_outsea_products',
      
      post_data     :'get_sale_post_data',

      prepay_money  :'get_use_prepay_money',
      amount_less   :'get_amount_less',

      have_this_gid :'have_this_gid'

    }),
    bill_money(){
        let money = this.sum_info.total_money - this.sum_info.use_prepay;
        if(parseInt(money) == money) return money;
        return 1* (money.toFixed(2));
    },
  },
  methods: {
    ...mapMutations({
        inc_mul_index   :'PRODUCTS_LIST_INC_MUL_INDEX',
        set_discount    :'PRODUCTS_DISCOUNT_SELECTED',
        act_tab         :'SHOW_DIALOG_ACTIVE_TAB',
    }),
    lookup_vip_info(mobile,callback){
        let self  = this;
        self.$store.dispatch('act_lookup_vip',{ 
            mobile   :mobile,
            callback :callback?callback:(data,tab='tab-sale')=>{
                self.act_tab(tab);
                if(data.vip) self.clear_input();//founed
            }
        });
    },
    add_custom_item(gid,name,money,is_new=true){
        var money = parseFloat(money);
        var obj = {oper :'add',num:1};
            obj["gid"]       = gid;
            obj["name"]      = name;
            obj["is_weight"] = false;
            obj["discount"]  = 100;
            obj['unit']      = 'pc';
            obj["in_price"]  = obj["real_price"] =  obj["sale_price"] = money;
            obj["all_num"]   = obj["save_num"]   =  obj["less"] = 0;
            obj["vip_price"] = {'vip': money};
            obj['save_take'] = 'sale';
            obj['is_new']    = is_new;
        this.edit_item(obj);
    },
    gid_input: debounce(function(e){
            let gid = this.input_gid
            if(gid && gid.length >2){
                this.lookup_product();
            }else if(!gid){
              this.act_tab('tab-sale')
            }
        },350),
    lookup_products_bat(array){
        let self = this;
        async function each_gid(){
            for(let it of array){
                let gid = it.trim();
                if(self.have_this_gid(gid)){
                   self.$store.commit('PRODUCTS_EDIT_ITEM',{
                    gid,
                    oper:'inc_num',
                    value:1
                   })
                   continue;
                }else{
                    console.log("=============>",gid)
                    await self.$store.dispatch('act_lookup_products_by_gid',{
                      gid,
                      prepare:false,
                      self,
                      callback :null,
                      raw:true
                    }).then(async list=>{
                       if(!list) list =[];
                       if(list.data) list = list.data;
                       if(list.length == 0){
                          await self.input_custom_product("请输入临时商品:"+gid).then(doc=>{
                              self.add_custom_item(gid,doc.name,doc.money*1);
                              self.act_tab('tab-sale');
                          }).catch(err=>{})
                       }else if(list.length ==1){
                            // console.log("RECV ONE:",list[0].name)
                            list[0].oper = 'add';
                            list[0].vip = self.$store.getters.vip_info.mobile;
                            self.$store.commit('PRODUCTS_EDIT_ITEM',list[0]);
                       }
                    })
                }
            }

        }
        each_gid()
    },
    lookup_product(enter){
        var self = this;
        var gid = self.input_gid.trim();

        let array = gid.split(/\s+/);
        if (array.length > 1) {
            self.clear_input();
            self.lookup_products_bat(array);
            console.log("LOOKUP BAT Count:",array.length)
        }

        if (self.pay_info.pay_status) return self.reset_state();

        if (/^[+-]([0-9]*\.?[0-9]+)$/.test(gid)) {
            if (!enter) return;
            var money = parseFloat(gid);
            var gid = "0000000000" + this.mutil_index;
            var name = "临时输入" + this.mutil_index;

            self.add_custom_item(gid, name, money, false)
            self.inc_mul_index(1);
            self.act_tab('tab-sale');
            self.clear_input();
            return;
        }
        if (!enter && /^1[345789]/.test(gid) && gid.length < 11) {
            return;
        }

        if (/^1[345789]\d{9}$/.test(gid)) {
            self.lookup_vip_info(gid);
        } else if (self.command_list(gid, enter)) {

        } else if (gid.length) {
            if (self.have_this_gid(gid)) {
                self.clear_input();
                return self.$store.commit('PRODUCTS_EDIT_ITEM', {
                    gid,
                    oper: 'inc_num',
                    value: 1
                })
            }
            self.$store.dispatch('act_lookup_products_by_gid', {
                gid,
                prepare: !enter,
                self,
                callback: (data, tab = "tab-prepare") => {
                    self.act_tab(tab);
                    if (tab == 'tab-sale')
                        self.clear_input()
                }
            }).then(list => {
                if (!list) list = [];
                if (list.data) list = list.data;
                if (list.length == 0 && enter) {
                    self.input_custom_product("请输入临时商品").then(doc => {
                        self.add_custom_item(gid, doc.name, doc.money * 1);
                        self.clear_input();
                        self.act_tab('tab-sale');
                    }).catch()
                }
            })
        } else {
            console.log('KEY DOWN:', gid, gid.length);
            if (self.prodcuts_list.length)
                self.do_pay_money();
        }
    },
    vip_prepay_fake_order:function(order_id,mobile,pay_info,note="") {
        return {
            "order_id": order_id,
            "sum":{
                "total_num"   : 1,
                "total_money" : pay_info.total_money,
                "recv"        : pay_info.recv_money,
                "pay_type"    : pay_info.pay_type,
                "bank_id"     : pay_info.bank_id,
                "where"       : pay_info.where,
                "auth_code"   : pay_info.auth_code
            },
            "detail": [{
                "gid"       : pay_info.total_money+'',
                "nm"        : "会员充值-"+pay_info.total_money,
                "num"       : 1,
                "price"     : pay_info.total_money,
                "realprice" : pay_info.total_money,
                "money"     : pay_info.total_money,
                "less"      : pay_info.ext,
                "save_num"  : 0,
                "flag"      : "prepay",
                "change_to" : null
            }],
            "note": note||'',
            "vip": {
                "vip_mobile": mobile,
                "vip_discount": 100
            },
        }
    },
    sale_detail: function(pay_info,my_info=null) {
        let sale_info           = my_info?my_info:this.post_data;
        // debugger total_money
        sale_info.sum.recv      = parseFloat(pay_info.recv_money);
        sale_info.sum.ret       = (sale_info.sum.recv > pay_info.total_money)?(sale_info.sum.recv - pay_info.total_money):0;
        sale_info.sum.pay_type  = pay_info.pay_type;
        sale_info.sum.bank_id   = pay_info.bank_id;
        sale_info.sum.auth_code = pay_info.auth_code;
        
        sale_info.sum.where    =  pay_info.taobao ? 'taobao' :
                                  (pay_info.pay_type == 'mall') ? "mall" : "store";
      /************sum part*************************************/
      return sale_info;
    },
    do_post_sale(post_obj) {
        let self = this;
        return sale_api.sale({ data: post_obj }).then(resp => {
            if (resp.status == 200) {
                if(resp.data.order_id == self.order_id)
                    self.$store.commit('PAYINFO_SETTING', {
                        pay_status  : 1,
                        title       : "",
                        pay_type    : post_obj.sum.pay_type,
                        total_money : post_obj.sum.total_money,
                        use_prepay  : post_obj.sum.use_prepay,
                        bank_id     : post_obj.sum.bank_id,
                        recv        : post_obj.sum.recv,
                        // ret         : post_obj.sum.pay_type == 'cash' ? (post_obj.sum.recv - post_obj.sum.total_money) : 0,
                        ret         : post_obj.sum.pay_type == 'cash' ? (post_obj.sum.recv - (post_obj.sum.total_money - post_obj.sum.use_prepay)) : 0,
                        other       : post_obj.sum.where
                    })
                return resp.data;
            }
        }).catch(err => {
            let err_msg = "";
            if (err.response && err.response.data) {
              err_msg = err.response.data;
            } else {
              err_msg = err.message;
            }
            self.$notify({ group: "msgpad", title: "错误", text: err_msg, type: "error" });
        })
    },
    clear_vip() {
      this.$store.commit('VIP_SET_VIP_INFO', {})
      this.$store.commit('PRODUCTS_RESET_VIP_PRICE', "")
      this.$store.commit('PRODUCTS_PREPARE_LIST',[])
      this.$store.commit('USE_PREPAY_MONEY', 0.0)
    },
    reset_state(){
        this.$store.commit('VIP_SET_VIP_INFO',{})
        this.$store.commit('PRODUCTS_LIST_CLEAN')
        this.$store.commit('PRODUCTS_PREPARE_LIST',[])
        this.$store.commit('USE_PREPAY_MONEY', 0.0)
        this.act_tab('tab-sale');
    },
    not_use_prepay_money(){
        // this.$store.commit('VIP_PREPAY_MONEY', this.vip_info.prepay_money + this.prepay_money);
        this.make_to_int(false);
        this.$store.commit('VIP_PREPAY_MONEY_ADJUST',this.prepay_money);
        this.$store.commit('USE_PREPAY_MONEY', 0.0)
        return;
    },
    not_use_amount(){
        // this.$store.commit('VIP_PREPAY_MONEY', this.vip_info.prepay_money + this.prepay_money);
        if(this.amount_less){
            this.make_to_int(false);
            this.$store.commit('VIP_AMOUNT_ADJUST',parseInt(this.amount_less*200));
            this.$store.commit('PRODUCTS_EDIT_ITEM',{oper:'vip_use_amount',gid:'',value:0});
        }
    },
    make_to_int(oper){
        let flag= (oper ==undefined)?((this.sum_info.less_to_int>0)?false:true):oper;
        // debugger
        this.$store.commit('PRODUCTS_EDIT_ITEM',{oper:'make_to_int',gid:'',value:flag});
    },
    use_prepay_money() {
      if (this.pay_info.pay_status > 0) {
        this.msgpad_show("msgpad", "ERROR", '本单已经结算！', 'error');
        return;
      };
      if (this.prepay_money > 0.01) {
        this.not_use_prepay_money();
        return;
      }
      if (this.vip_info.prepay_money) {
        this.make_to_int(false);
        var total_money = this.sum_info.total_money;

        if (this.vip_info.prepay_money > total_money) {
          this.$store.commit('USE_PREPAY_MONEY', total_money)
        } else {
          this.$store.commit('USE_PREPAY_MONEY', this.vip_info.prepay_money)
        }
        this.$store.commit('VIP_PREPAY_MONEY', this.vip_info.prepay_money - this.prepay_money);
      }
    },
    use_amount(){
        // debugger
        if (this.pay_info.pay_status > 0) {
            this.msgpad_show("msgpad", "ERROR", '本单已经结算！', 'error');
            return;
        };
        if (this.amount_less > 0.01) {
            this.not_use_amount();
            return;
        }
        if (this.vip_info.user_amount) {
            this.make_to_int(false);
            var total_money = this.sum_info.total_money;
            if(this.prepay_money){
                total_money -= this.prepay_money;
            }
            if(total_money ==0) return;
            let as_money = this.vip_info.user_amount/200;
            let less_money = as_money > total_money ? total_money:as_money;

            this.$store.commit('PRODUCTS_EDIT_ITEM',{oper:'vip_use_amount',gid:'',value:less_money});
            this.$store.commit('VIP_AMOUNT_ADJUST',parseInt(less_money*200*-1));
        }
    },


    check_weixin_alipy_state(order_id, type) {
      sale_api.check_pay_state_3part({
        order_id,
        type
      }).then(obj => {
        // if(obj.trade_status =="TRADE_SUCCESS" || obj.trade_state =="SUCCESS" ){
        // }else{

        // }
      })
    },
    show_dialog(type,val= true){
        this.$store.commit(type,val)
    },
    msgpad_show(group,title,text,type){
        this.$notify({ group, title, text, type})
    },
    ready_for_sale(type=''){
        let text = '';
        if(this.prodcuts_list.length == 0)   text = '无待操作商品 ';
        if(this.pay_info.pay_status !=0  )   text = '本单已经结算！';

        if(type != '') return true;

        if(Object.keys(this.outsea_products).length >0){
           if(!this.vip_info.mobile){
              text="跨境商品需要会员信息！";
           } 
           else if(this.vip_info.spec_info.userid && this.vip_info.spec_info.valid){
              return true;
           }else{
             this.show_dialog('SHOW_DIALOG_EDITVIP','valid');
             text='需要验证会员身份证！'
           }
        }
        if(text){
            this.$notify({
                    group: 'msgpad',
                    type: 'error',
                    title: '操作失败！',
                    text
            })
            return false
        }
        return true;
    },
    
    input_custom_product(title){
        return new Promise((resove,reject)=>{
            let dlg_conf = {
                title,
                fields:[
                    {
                        title       :'商品名称',
                        placeholder :'商品名称',
                        type        :"string",
                        value       : '',
                        name        :'name',
                        err_msg     :[],
                        rules       :[v => !!v|| "商品名称是必须的"]
                    },
                    {
                        title       :'零售价',
                        placeholder :'零售价',
                        type        :"number",
                        value       : 0,
                        name        :'money',
                        rules       :[v=> (1*v)== 0||/[0-9]*\.?[0-9]+$/.test(v)||"金额格式不正确"],
                        err_msg     :[]
                    }
                ],
                action :({close,self,type,data})=>{
                    if(type=='cancel') return reject('cancel');
                    let ok = self.$refs.form.validate();
                    if(!ok) return reject(false);
                    self.close_dialog();
                    return resove(data);
                }
            }
            this.$store.commit('USER_INPUT_FIELDS',dlg_conf)
        })
    },
    
  }
}



// WEBPACK FOOTER //
// ./src/views/front_sale/mixin/mix_sale.js